import React, { useEffect, useMemo, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import Loading from '~/components/Loading'
import { getPublisherDestinationUrls } from '~/modules/retailMedia/store/industry/publisherConfiguration/actions'
import { useAppSelector } from '~/store/hooks'

import AlertBrandsPureComponent from './PureComponent'
import { useGetFetchQuery } from '~/hooks/useGetFetchQuery'

// Poderíamos ter pego esse valor de publisherId pelo Redux. Achei melhor manter por props
// para facilitar o uso no create que não temos dados ainda e em caso de optarmos
// usar em listas de vários publishers.

const AlertBrands: React.FC<AlertBrandsProps> = ({ publisherId }) => {
  const publisherInfo = useGetFetchQuery<GetPublisherResponse>([
    'getAccountInfo',
    publisherId
  ])

  const {
    industry: {
      publisherConfiguration: {
        listDestinationUrls: { data, loading, error }
      }
    }
  } = useAppSelector(state => state.retailMedia)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!data && !!publisherId) {
      dispatch(getPublisherDestinationUrls(publisherId))
    }
  }, [data, dispatch, publisherId])

  const publisherBrands = useMemo(() => data?.destinations, [data])

  const showAlert = useMemo(
    () => data?.has_brands && !publisherInfo?.is_network,
    [data, publisherInfo?.is_network]
  )

  return (
    (loading || error || showAlert) && (
      <div className="alertBrands">
        {loading && (
          <Loading status={loading}>{t('rm:publisher.brands.loading')}</Loading>
        )}

        {error && (
          <Alert variant="critical">
            {t('rm:publisher.brands.loading.error')}
          </Alert>
        )}

        {showAlert && (
          <AlertBrandsPureComponent
            publisherBrands={publisherBrands as Brand[]}
          />
        )}
      </div>
    )
  )
}

export default AlertBrands
